import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/redux';
import { checkBusinessEntity as checkBusinessEntityService } from '../../../services/megalanding/checkBusinessEntity';
import { ValidationError } from '@cian/peperrors';
import { TBusinessEntityValidationState } from '../../../slices/businessEntityFlow';
import { IPublicV1PublicOfferCheckBusinessEntityResponseSchema } from 'shared/repositories/dailyrent/entities/response/PublicV1PublicOfferCheckBusinessEntityResponseSchema';

export const checkBusinessEntity = createAsyncThunk<
  IPublicV1PublicOfferCheckBusinessEntityResponseSchema,
  { onLoadingStart(): void },
  IThunkApi & {
    rejectValue: TBusinessEntityValidationState['errorCode'];
  }
>('megalanding/checkBusinessEntity', async ({ onLoadingStart }, thunkApi) => {
  const { extra: context } = thunkApi;

  try {
    onLoadingStart();

    return await checkBusinessEntityService(context);
  } catch (e) {
    if (e instanceof ValidationError && e.details && 'errorCode' in e.details) {
      const errorCode = e.details.errorCode as TBusinessEntityValidationState['errorCode'];

      return thunkApi.rejectWithValue(errorCode);
    }

    return thunkApi.rejectWithValue('unknown');
  }
});
